import { InMemoryCache } from "@apollo/client";
import { createFragmentRegistry } from "@apollo/client/cache";
import type { DocumentNode } from "graphql";
import * as generated from "../generated/graphql";

// Codegen emits standalone fragments without their nested definitions. Apollo
// resolves those spreads through this registry for both cache reads and writes.
// Discover exports so regenerating GraphQL cannot silently omit new fragments.
export const createAppFragmentRegistry = () =>
  createFragmentRegistry(
    ...Object.entries(generated).flatMap(([name, document]) =>
      name.endsWith("FragmentDoc") ? [document as DocumentNode] : [],
    ),
  );

export const createAppCache = () =>
  new InMemoryCache({
    fragments: createAppFragmentRegistry(),
    typePolicies: {
      Query: {
        fields: {
          // Independent flow queries share this singleton grouping object.
          Flow: { merge: true },
          // Report filter lookups independently populate this namespace.
          ShipmentReport: { merge: true },
        },
      },
    },
  });
